import React, { useContext, useReducer } from 'react'

const PlayerContext = React.createContext()

const initState = {
  isPlaying: false,
  currentTime: 0.0,
  totalTime: 1.0,
  volume: 50,
  guideVolume: 30
}

export const UPDATE_BACKGROUND_VOLUME = 'UPDATE_BACKGROUND_VOLUME'
export const UPDATE_GUIDE_VOLUME = 'UPDATE_GUIDE_VOLUME'
export const UPDATE_CURRENT_TIME = 'UPDATE_CURRENT_TIME'
export const UPDATE_PLAY_PAUSE = 'UPDATE_PLAY_PAUSE'
export const UPDATE_TOTAL_TIME = 'UPDATE_TOTAL_TIME'

function playerReducer(state, action) {
  switch (action.type) {
    case UPDATE_BACKGROUND_VOLUME:
      return {
        ...state,
        volume: action.payload
      }

    case UPDATE_GUIDE_VOLUME:
      return {
        ...state,
        guideVolume: action.payload
      }
    case UPDATE_CURRENT_TIME:
      return {
        ...state,
        currentTime: action.payload
      }
    case UPDATE_PLAY_PAUSE:
      return {
        ...state,
        isPlaying: action.payload
      }
    case UPDATE_TOTAL_TIME:
      return {
        ...state,
        totalTime: action.payload
      }
    default:
      return { ...state }
  }
}

function PlayerProvider({ children }) {
  const [state, dispatch] = useReducer(playerReducer, initState)

  const value = { state, dispatch }

  return (
    <PlayerContext.Provider value={value}>{children}</PlayerContext.Provider>
  )
}

function usePlayer() {
  const context = useContext(PlayerContext)

  if (context === undefined) {
    throw new Error('usePlayer must be used within a PlayerProvider')
  }

  return context
}

export { PlayerProvider, usePlayer }
